import { RenderItemProps, VirtualList } from '@shared/components/ui/VirtualList';
import { useTranslation } from 'react-i18next';
import { ExtraWorkOrder } from '../../models';
import { Card } from './Card';

interface CardListProps {
  orders: ExtraWorkOrder[];
  isLoading?: boolean;
  className?: string;
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  sorting?: any;
  onSortingChange?: (sorting: any) => void;
  total?: number;
  showActions?: boolean;
  estimateItemHeight?: number;
}

/**
 * CardList - Lista de cards para vista móvil
 */
export const CardList = ({
  orders,
  fetchNextPage,
  hasNextPage = false,
  isFetchingNextPage = false,
  sorting,
  onSortingChange,
  total,
  className = '',
  showActions = true,
  estimateItemHeight = 140,
}: CardListProps) => {
  const { t } = useTranslation('extraWorkOrdersModule');

  // Render function que usa el componente Card
  const renderOrderCard = (props: RenderItemProps<ExtraWorkOrder>) => <Card {...props} showActions={showActions} />;

  // Key generator para optimizar renders
  const getOrderKey = (order: ExtraWorkOrder) => {
    return order.id;
  };

  return (
    <VirtualList
      data={orders}
      renderItem={renderOrderCard}
      itemKey={getOrderKey}
      estimateItemHeight={estimateItemHeight}
      height="calc(100vh - 150px)"
      gap={0}
      emptyMessage={t('list.empty.message', 'No se encontraron órdenes de trabajos extra con los filtros aplicados.')}
      className={`rounded-lg shadow-sm ${className}`}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      infiniteScrollThreshold={300}
      sorting={sorting}
      onSortingChange={onSortingChange}
      total={total}
      listClassName="touch-pan-y"
      itemClassName="touch-manipulation"
    />
  );
};
